export default __webpack_public_path__ + "static/media/0707ROUGE.cc962bdf.pdf";